import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CustomerRetrievalSection from "./CustomerRetrievalSection";
import { IPatientDetails } from "../types/PrescriptionIngestionTypes";

interface CustomerSearchSectionProps {
  onCustomerRetrieved: (details: Partial<IPatientDetails>) => void;
  onIdsRetrieved?: (ids: { personId?: string; profileId?: string }) => void;
  scrollTargetRef?: React.RefObject<HTMLDivElement>;
  searchKey?: number;
}

const CustomerSearchSection: React.FC<CustomerSearchSectionProps> = ({
  onCustomerRetrieved,
  onIdsRetrieved,
  scrollTargetRef,
  searchKey,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Alert severity="info">
          <Typography
            variant="body2"
            style={{ fontWeight: "bold", marginBottom: 4 }}
          >
            Important: Linking Rx to Existing AP Customer
          </Typography>
          <Typography variant="body2">
            If you have an existing Amazon Pharmacy customer, use the search
            below to auto-fill their details, or enter the patient details{" "}
            <strong>exactly as they appear in the customer's profile</strong>{" "}
            (name, date of birth, address, etc.). This ensures the prescription
            will be properly linked to their account.
          </Typography>
        </Alert>
      </Grid>

      <CustomerRetrievalSection
        key={searchKey}
        onCustomerRetrieved={onCustomerRetrieved}
        onIdsRetrieved={onIdsRetrieved}
        onSuccess={() => {
          if (scrollTargetRef?.current) {
            scrollTargetRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }}
      />
    </>
  );
};

export default CustomerSearchSection;
